import React, { useEffect, useState } from 'react';
import './style.css';
import './i18n';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher'; // au début
import AdminSidebar from './components/AdminSidebar';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import VillaInfo from './components/VillaInfo';
import MapSection from './components/MapSection';
import AirbnbCalendar from './components/AirbnbCalendar';
import GallerySection from './components/GallerySection';
import ChatWidget from './components/ChatWidget';
import Footer from './components/Footer';
import GalleryVrac from './components/GalleryVrac';

import { useLocation } from 'react-router-dom';
import i18n from './i18n';

import SEOHead from './components/SEOHead';
import { clearAuth } from './utils/auth';

const App = ({ lang }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('villaAuthenticated') === 'true';
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const sitePathByLang = {
    fr: '/fr/location-maison-appartement-sardaigne-san-teodoro',
    it: '/it/affitto-villa-appartamento-sardegna-san-teodoro',
    en: '/en/sardinia-villa-apartment-rental-san-teodoro',
    de: '/de/ferienhaus-sardinien-san-teodoro',
    pt: '/pt/aluguel-villa-sardenha-san-teodoro',
    es: '/es/alquiler-villa-sardinia-san-teodoro',
    ru: '/ru/arenda-villy-sardinija-san-teodoro'
  };

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, location]);

  useEffect(() => {
    const syncAuthentication = () => {
      setIsAuthenticated(localStorage.getItem('villaAuthenticated') === 'true');
    };

    window.addEventListener('storage', syncAuthentication);
    window.addEventListener('villa-auth-changed', syncAuthentication);

    return () => {
      window.removeEventListener('storage', syncAuthentication);
      window.removeEventListener('villa-auth-changed', syncAuthentication);
    };
  }, []);

  const handleLogout = () => {
    clearAuth();
    setIsAuthenticated(false);
  };

  // Préparation du tableau allGalleries
  const allGalleries = [
    {
      title: t('gallery.interiorTitle'),
      description: t('gallery.interiorDesc'),
      images: t('gallery.interiorImages', { returnObjects: true }),
      backgroundColor: "#fbf0e0"
    },
    {
      title: t('gallery.exteriorTitle'),
      description: t('gallery.exteriorDesc'),
      images: t('gallery.exteriorImages', { returnObjects: true }),
      backgroundColor: "#ffffff"
    },
    {
      title: t('gallery.beachTitle'),
      description: t('gallery.beachDesc'),
      images: t('gallery.beachImages', { returnObjects: true }),
      backgroundColor: "#ffffff"
    },
    {
      title: t('gallery.todoTitle'),
      description: t('gallery.todoDesc'),
      images: t('gallery.todoImages', { returnObjects: true }),
      backgroundColor: "#fbf0e0"
    },
    {
      title: t('gallery.activityTitle'),
      description: t('gallery.activityDesc'),
      images: t('gallery.activityImages', { returnObjects: true }),
      backgroundColor: "#ffffff"
    }
  ];

  return (
    <>
      <SEOHead lang={lang} key={lang} />
      <div className="site-shell">
        {isAuthenticated && (
          <AdminSidebar
            isOpen={isSidebarOpen}
            onToggle={() => setIsSidebarOpen((open) => !open)}
            onLogout={handleLogout}
            sitePath={sitePathByLang[lang] || sitePathByLang.it}
          />
        )}
        <div className="site-shell-content">
          <Header />
          <LanguageSwitcher />
          <HeroSection />
          <VillaInfo />
          <GallerySection
            title={allGalleries[0].title}
            description={allGalleries[0].description}
            images={allGalleries[0].images}
            backgroundColor={allGalleries[0].backgroundColor}
            allGalleries={allGalleries}
          />
          <GallerySection
            title={allGalleries[1].title}
            description={allGalleries[1].description}
            images={allGalleries[1].images}
            backgroundColor={allGalleries[1].backgroundColor}
            allGalleries={allGalleries}
          />
          <AirbnbCalendar lang={lang} />
          <MapSection />
          <GallerySection
            title={allGalleries[2].title}
            description={allGalleries[2].description}
            images={allGalleries[2].images}
            backgroundColor={allGalleries[2].backgroundColor}
            allGalleries={allGalleries}
          />
          <GallerySection
            title={allGalleries[3].title}
            description={allGalleries[3].description}
            images={allGalleries[3].images}
            backgroundColor={allGalleries[3].backgroundColor}
            allGalleries={allGalleries}
          />
          <GallerySection
            title={allGalleries[4].title}
            description={allGalleries[4].description}
            images={allGalleries[4].images}
            backgroundColor={allGalleries[4].backgroundColor}
            allGalleries={allGalleries}
          />
          <GalleryVrac
            folder={t('galleryVrac.dossier')}
            title={t('galleryVrac.title')}
            description={t('galleryVrac.description')}
          />
          <ChatWidget />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
